import React, { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import './style.css';
import { t } from "i18next";
const MultipleSelect = ({ options, name, onSelectionChange, formError, selectedValues, field_second, label, lang, field }) => {

    const sellectedValues = Array.isArray(selectedValues)
        ? selectedValues.map(option => {
            const primaryLabel = field
                ? lang
                    ? option?.[field]?.[lang]
                    : option?.[field]
                : lang
                    ? option?.[name]?.[lang]
                    : option?.[name];

            const secondaryLabel = field_second
                ? lang
                    ? option?.[field_second]?.[lang]
                    : option?.[field_second]
                : null;

            const optionLabel = primaryLabel || primaryLabel === null
                ? `${primaryLabel}${field_second !== undefined
                    ? (secondaryLabel !== null
                        ? ` - ${secondaryLabel}`
                        : ` - ${t('common.no_name')}`)
                    : ""}`
                : t('common.no_name');

            return {
                id: option?.id,
                value: option?.id,
                label: optionLabel
            };
        })
        : [];


    const [selected, setSelected] = useState(sellectedValues);
    const transformedOptions = options.map(option => {
        const primaryLabel = field
            ? lang
                ? option?.[field]?.[lang]
                : option?.[field]
            : lang
                ? option?.[name]?.[lang]
                : option?.[name];

        const secondaryLabel = field_second
            ? lang
                ? option?.[field_second]?.[lang]
                : option?.[field_second]
            : null;

        const optionLabel = primaryLabel || primaryLabel === null
            ? `${primaryLabel}${field_second !== undefined
                ? (secondaryLabel !== null
                    ? ` - ${secondaryLabel}`
                    : ` - ${t('common.no_name')}`)
                : ""}`
            : t('common.no_name');

        return {
            id: option.id,
            value: option.id,
            label: optionLabel
        };
    });


    useEffect(() => {
        const values = selected.map(obj => obj.id);
        onSelectionChange(values);
    }, [selected]);
    return (
        <div className="col-md-6">
            <label className="form-label">
                {label}
            </label>
            {/* <div>
                <ShowMoreComponent items={selected.map(obj => obj.label)} maxVisible={5} />
            </div> */}
            <MultiSelect
                options={transformedOptions}
                value={selected}
                onChange={setSelected}
                labelledBy="Select"
                name={name}
                className="multi-select-container"
            />
            {formError?.servicepoint_ids && (<div className="invalid-feedback">{formError?.servicepoint_ids.join(', ')}</div>)}
        </div>
    );
};

export default MultipleSelect;
